// // src/pages/Reports/tables/NormalReportTable.js
// import React, { useState, useEffect, useMemo } from "react"
// import { getCombinedTransactionReport } from "../../../helpers/api_helper"

// const NormalReportTable = ({ filters }) => {
//   const [expandedRows, setExpandedRows] = useState({})
//   const [tableData, setTableData] = useState([]) // original / full data
//   const [filteredData, setFilteredData] = useState([]) // shown after search
//   const [searchTerm, setSearchTerm] = useState("")
//   const [loading, setLoading] = useState(true)
//   const [totalRecords, setTotalRecords] = useState(0)
//   const [pageIndex, setPageIndex] = useState(0)
//   const [pageSize, setPageSize] = useState(10)

//   const fetchData = async (
//     newPageIndex = pageIndex,
//     newPageSize = pageSize
//   ) => {
//     setLoading(true)
//     const offset = newPageIndex * newPageSize

//     try {
//       const res = await getCombinedTransactionReport({
//         limit: newPageSize,
//         offset,
//         startDate: filters?.startDate || null,
//         endDate: filters?.endDate || null,
//         mobileNumber:
//           filters?.mobileNumbers?.length > 0 ? filters.mobileNumbers : null,
//       })

//       console.log("Normal Report API Response:", res)

//       if (!res.success || !res.data) {
//         setTableData([])
//         setFilteredData([])
//         setTotalRecords(0)
//         return
//       }

//       setTotalRecords(res.totalRecords || 0)

//       let rows = []

//       Object.entries(res.data || {}).forEach(([date, mobiles]) => {
//         Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
//           const openingClosing = categories.opening_closing || {}

//           const withdrawTotal = categories.withdraw?.total?.amount || 0
//           const addedTotal = categories.added_money?.total?.amount || 0

//           const withdrawDetails = categories.withdraw?.details || []
//           const addedDetails = categories.added_money?.details || []

//           const subTransactions = [
//             ...withdrawDetails.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Withdraw",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//             ...addedDetails.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Added Money",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//           ]

//           rows.push({
//             id: `${date}-${mobile}`,
//             dateTime: openingClosing.opening_time || date || "",
//             mobile: mobile.trim(),
//             opening: openingClosing.opening || 0,
//             closing: openingClosing.closing || 0,
//             withdraw: withdrawTotal,
//             added: addedTotal,
//             subTransactions,
//           })
//         })
//       })

//       rows.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime))

//       setTableData(rows)
//       setFilteredData(rows) // initially show all
//       setPageIndex(newPageIndex)
//       setPageSize(newPageSize)
//     } catch (err) {
//       console.error("Normal Report fetch error:", err)
//       setTableData([])
//       setFilteredData([])
//       setTotalRecords(0)
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     fetchData(0, pageSize)
//   }, [filters, pageSize])

//   // Client-side search filtering
//   useEffect(() => {
//     if (!searchTerm.trim()) {
//       setFilteredData(tableData)
//       return
//     }

//     const term = searchTerm.toLowerCase().trim()

//     const filtered = tableData.filter(row => {
//       const mobileMatch = row.mobile.toLowerCase().includes(term)
//       const dateMatch = row.dateTime.toLowerCase().includes(term)
//       return mobileMatch || dateMatch
//     })

//     setFilteredData(filtered)
//     setPageIndex(0) // reset to first page on new search
//   }, [searchTerm, tableData])

//   const formatCurrency = val => `₹${Number(val || 0).toLocaleString("en-IN")}`

//   const toggleExpand = id => {
//     setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }))
//   }

//   const renderSubTable = (subTransactions = []) => (
//     <div className="bg-light p-4 border-top">
//       <h6 className="mb-3 fw-semibold">Transaction History</h6>
//       <div className="table-responsive">
//         <table className="table table-bordered table-sm mb-0">
//           <thead className="table-light">
//             <tr>
//               <th>Date Time</th>
//               <th>Type</th>
//               <th>Amount</th>
//               <th>Transaction ID</th>
//             </tr>
//           </thead>
//           <tbody>
//             {subTransactions.length > 0 ? (
//               subTransactions.map((sub, idx) => (
//                 <tr key={idx}>
//                   <td>{sub.dateTime || "N/A"}</td>
//                   <td>{sub.type || "N/A"}</td>
//                   <td>{formatCurrency(sub.amount)}</td>
//                   <td>{sub.transactionId || "N/A"}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={4} className="text-center text-muted py-3">
//                   No detailed transactions available in this report
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   )

//   // Export uses filtered data (what user is currently seeing)
//   const handleExportCSV = () => {
//     if (loading || filteredData.length === 0) {
//       alert("No data available to export right now.")
//       return
//     }

//     const dateStr = new Date().toISOString().split("T")[0]
//     const filename = `normal-report_${dateStr}.csv`

//     const headers = [
//       "Date Time (Main)",
//       "Mobile",
//       "Opening",
//       "Closing",
//       "Withdraw (Total)",
//       "Added (Total)",
//       "Transaction Date Time",
//       "Type",
//       "Amount",
//       "Transaction ID",
//     ]

//     const csvRows = [headers.join(",")]

//     filteredData.forEach(row => {
//       if (row.subTransactions.length === 0) {
//         const mainValues = [
//           `"${(row.dateTime || "").replace(/"/g, '""')}"`,
//           `"${(row.mobile || "").replace(/"/g, '""')}"`,
//           row.opening || 0,
//           row.closing || 0,
//           row.withdraw || 0,
//           row.added || 0,
//           "",
//           "",
//           "",
//           "",
//         ]
//         csvRows.push(mainValues.join(","))
//       } else {
//         row.subTransactions.forEach(sub => {
//           const values = [
//             `"${(row.dateTime || "").replace(/"/g, '""')}"`,
//             `"${(row.mobile || "").replace(/"/g, '""')}"`,
//             row.opening || 0,
//             row.closing || 0,
//             row.withdraw || 0,
//             row.added || 0,
//             `"${(sub.dateTime || "").replace(/"/g, '""')}"`,
//             `"${(sub.type || "").replace(/"/g, '""')}"`,
//             sub.amount || 0,
//             `"${(sub.transactionId || "").replace(/"/g, '""')}"`,
//           ]
//           csvRows.push(values.join(","))
//         })
//       }
//       csvRows.push(",")
//     })

//     const csvContent = csvRows.join("\n")
//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement("a")
//     link.href = url
//     link.setAttribute("download", filename)
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     URL.revokeObjectURL(url)
//   }

//   // Pagination based on filteredData
//   const totalPages = Math.ceil(filteredData.length / pageSize)
//   const paginatedData = useMemo(() => {
//     const start = pageIndex * pageSize
//     return filteredData.slice(start, start + pageSize)
//   }, [filteredData, pageIndex, pageSize])

//   const canGoPrev = pageIndex > 0
//   const canGoNext = pageIndex < totalPages - 1

//   const getPageNumbers = () => {
//     const pages = []
//     const maxVisible = 5
//     let start = Math.max(0, pageIndex - 2)
//     let end = Math.min(totalPages, start + maxVisible)

//     if (end - start < maxVisible) {
//       start = Math.max(0, end - maxVisible)
//     }

//     for (let i = start; i < end; i++) {
//       pages.push(i)
//     }
//     return pages
//   }

//   return (
//     <div className="table-responsive">
//       {/* Top Controls */}
//       <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="Search by mobile or date/time..."
//           value={searchTerm}
//           onChange={e => setSearchTerm(e.target.value)}
//         />
//         <div className="d-flex align-items-center gap-2">
//           <select
//             className="form-select w-auto"
//             value={pageSize}
//             onChange={e => {
//               setPageSize(Number(e.target.value))
//               setPageIndex(0)
//             }}
//           >
//             <option value={5}>Show 5</option>
//             <option value={10}>Show 10</option>
//             <option value={20}>Show 20</option>
//             <option value={50}>Show 50</option>
//           </select>

//           <button
//             className="btn btn-soft-primary btn-sm"
//             onClick={handleExportCSV}
//             disabled={loading || filteredData.length === 0}
//           >
//             <i className="mdi mdi-download me-1"></i> Export CSV
//           </button>
//         </div>
//       </div>

//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       ) : filteredData.length === 0 ? (
//         <div className="text-center py-5 text-muted">
//           <h5>
//             {tableData.length === 0
//               ? "No records found for the selected filters"
//               : "No matching records found for your search"}
//           </h5>
//         </div>
//       ) : (
//         <>
//           <table className="table table-bordered table-hover">
//             <thead className="table-light">
//               <tr>
//                 <th style={{ width: "50px" }}></th>
//                 <th>Date Time</th>
//                 <th>Mobile</th>
//                 <th>Opening</th>
//                 <th>Closing</th>
//                 <th>Withdraw</th>
//                 <th>Added</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData.map(row => (
//                 <React.Fragment key={row.id}>
//                   <tr>
//                     <td className="text-center">
//                       <button
//                         className="btn btn-sm btn-link p-0 fs-5"
//                         onClick={() => toggleExpand(row.id)}
//                       >
//                         {expandedRows[row.id] ? "▼" : "▶"}
//                       </button>
//                     </td>
//                     <td>{row.dateTime}</td>
//                     <td>{row.mobile}</td>
//                     <td>{formatCurrency(row.opening)}</td>
//                     <td>{formatCurrency(row.closing)}</td>
//                     <td>{formatCurrency(row.withdraw)}</td>
//                     <td>{formatCurrency(row.added)}</td>
//                   </tr>

//                   {expandedRows[row.id] && (
//                     <tr>
//                       <td colSpan={7} className="p-0">
//                         {renderSubTable(row.subTransactions)}
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination – now based on filtered data */}
//           <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//             <div className="text-muted">
//               Showing {paginatedData.length} of {filteredData.length} entries
//               {filteredData.length > 0 && (
//                 <span className="ms-2">
//                   Page {pageIndex + 1} of {totalPages}
//                 </span>
//               )}
//             </div>

//             <nav>
//               <ul className="pagination pagination-sm mb-0">
//                 <li className={`page-item ${!canGoPrev ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoPrev && setPageIndex(pageIndex - 1)}
//                     disabled={!canGoPrev}
//                   >
//                     Previous
//                   </button>
//                 </li>

//                 {getPageNumbers().map(pageNum => (
//                   <li
//                     key={pageNum}
//                     className={`page-item ${
//                       pageIndex === pageNum ? "active" : ""
//                     }`}
//                   >
//                     <button
//                       className="page-link"
//                       onClick={() => setPageIndex(pageNum)}
//                     >
//                       {pageNum + 1}
//                     </button>
//                   </li>
//                 ))}

//                 <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoNext && setPageIndex(pageIndex + 1)}
//                     disabled={!canGoNext}
//                   >
//                     Next
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </>
//       )}
//     </div>
//   )
// }

// export default NormalReportTable

// // src/pages/Reports/tables/NormalReportTable.js
// import React, { useState, useEffect, useRef, useMemo } from "react"
// import { getCombinedTransactionReport } from "../../../helpers/api_helper"

// const NormalReportTable = ({ filters }) => {
//   const [expandedRows, setExpandedRows] = useState({})
//   const [tableData, setTableData] = useState([]) // current page data from API
//   const [searchTerm, setSearchTerm] = useState("")
//   const [loading, setLoading] = useState(true)
//   const [totalRecords, setTotalRecords] = useState(0)
//   const [pageIndex, setPageIndex] = useState(0)
//   const [pageSize, setPageSize] = useState(5)

//   // Cache: key = `${pageIndex}-${pageSize}`, value = { rows: [], timestamp }
//   const cache = useRef(new Map())

//   const getCacheKey = (pIndex, pSize) => `${pIndex}-${pSize}`

//   const fetchData = async (
//     newPageIndex = pageIndex,
//     newPageSize = pageSize,
//     forceRefresh = false
//   ) => {
//     const key = getCacheKey(newPageIndex, newPageSize)

//     if (!forceRefresh && cache.current.has(key)) {
//       const cached = cache.current.get(key)
//       setTableData(cached.rows)
//       setPageIndex(newPageIndex)
//       setPageSize(newPageSize)
//       setLoading(false)
//       return
//     }

//     setLoading(true)
//     const offset = newPageIndex * newPageSize

//     try {
//       const res = await getCombinedTransactionReport({
//         limit: newPageSize,
//         offset,
//         startDate: filters?.startDate || null,
//         endDate: filters?.endDate || null,
//         mobileNumber:
//           filters?.mobileNumbers?.length > 0 ? filters.mobileNumbers : null,
//       })

//       console.log("Normal Report API Response:", res)

//       if (!res.success || !res.data) {
//         setTableData([])
//         setTotalRecords(0)
//         cache.current.delete(key)
//         return
//       }

//       setTotalRecords(res.totalRecords || 0)

//       let rows = []

//       Object.entries(res.data || {}).forEach(([date, mobiles]) => {
//         Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
//           const openingClosing = categories.opening_closing || {}

//           const withdrawTotal = categories.withdraw?.total?.amount || 0
//           const addedTotal = categories.added_money?.total?.amount || 0

//           const withdrawDetails = categories.withdraw?.details || []
//           const addedDetails = categories.added_money?.details || []

//           const subTransactions = [
//             ...withdrawDetails.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Withdraw",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//             ...addedDetails.map(detail => ({
//               dateTime: detail.time || "",
//               type: "Added Money",
//               amount: detail.amount || 0,
//               transactionId: detail.transaction_id || "N/A",
//             })),
//           ]

//           rows.push({
//             id: `${date}-${mobile}`,
//             dateTime: openingClosing.opening_time || date || "",
//             mobile: mobile.trim(),
//             opening: openingClosing.opening || 0,
//             closing: openingClosing.closing || 0,
//             withdraw: withdrawTotal,
//             added: addedTotal,
//             subTransactions,
//           })
//         })
//       })

//       rows.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime))

//       cache.current.set(key, { rows, timestamp: Date.now() })

//       setTableData(rows)
//       setPageIndex(newPageIndex)
//       setPageSize(newPageSize)
//     } catch (err) {
//       console.error("Normal Report fetch error:", err)
//       setTableData([])
//       setTotalRecords(0)
//       cache.current.delete(key)
//     } finally {
//       setLoading(false)
//     }
//   }

//   // Reset on filters or pageSize change
//   useEffect(() => {
//     setPageIndex(0)
//     fetchData(0, pageSize)
//   }, [filters, pageSize])

//   // Client-side search filtering on current page data
//   const filteredRows = useMemo(() => {
//     if (!searchTerm.trim()) return tableData

//     const term = searchTerm.toLowerCase().trim()

//     return tableData.filter(row => {
//       return (
//         row.mobile.toLowerCase().includes(term) ||
//         row.dateTime.toLowerCase().includes(term)
//       )
//     })
//   }, [searchTerm, tableData])

//   const formatCurrency = val => `₹${Number(val || 0).toLocaleString("en-IN")}`

//   const toggleExpand = id => {
//     setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }))
//   }

//   const renderSubTable = (subTransactions = []) => (
//     <div className="bg-light p-4 border-top">
//       <h6 className="mb-3 fw-semibold">Transaction History</h6>
//       <div className="table-responsive">
//         <table className="table table-bordered table-sm mb-0">
//           <thead className="table-light">
//             <tr>
//               <th>Date Time</th>
//               <th>Type</th>
//               <th>Amount</th>
//               <th>Transaction ID</th>
//             </tr>
//           </thead>
//           <tbody>
//             {subTransactions.length > 0 ? (
//               subTransactions.map((sub, idx) => (
//                 <tr key={idx}>
//                   <td>{sub.dateTime || "N/A"}</td>
//                   <td>{sub.type || "N/A"}</td>
//                   <td>{formatCurrency(sub.amount)}</td>
//                   <td>{sub.transactionId || "N/A"}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={4} className="text-center text-muted py-3">
//                   No detailed transactions available in this report
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   )

//   const handleExportCSV = () => {
//     const dataToExport = searchTerm.trim() ? filteredRows : tableData

//     if (loading || dataToExport.length === 0) {
//       alert("No data available to export right now. (Current view only)")
//       return
//     }

//     const dateStr = new Date().toISOString().split("T")[0]
//     const filename = `normal-report_${dateStr}.csv`

//     const headers = [
//       "Date Time (Main)",
//       "Mobile",
//       "Opening",
//       "Closing",
//       "Withdraw (Total)",
//       "Added (Total)",
//       "Transaction Date Time",
//       "Type",
//       "Amount",
//       "Transaction ID",
//     ]

//     const csvRows = [headers.join(",")]

//     dataToExport.forEach(row => {
//       if (row.subTransactions.length === 0) {
//         const mainValues = [
//           `"${(row.dateTime || "").replace(/"/g, '""')}"`,
//           `"${(row.mobile || "").replace(/"/g, '""')}"`,
//           row.opening || 0,
//           row.closing || 0,
//           row.withdraw || 0,
//           row.added || 0,
//           "",
//           "",
//           "",
//           "",
//         ]
//         csvRows.push(mainValues.join(","))
//       } else {
//         row.subTransactions.forEach(sub => {
//           const values = [
//             `"${(row.dateTime || "").replace(/"/g, '""')}"`,
//             `"${(row.mobile || "").replace(/"/g, '""')}"`,
//             row.opening || 0,
//             row.closing || 0,
//             row.withdraw || 0,
//             row.added || 0,
//             `"${(sub.dateTime || "").replace(/"/g, '""')}"`,
//             `"${(sub.type || "").replace(/"/g, '""')}"`,
//             sub.amount || 0,
//             `"${(sub.transactionId || "").replace(/"/g, '""')}"`,
//           ]
//           csvRows.push(values.join(","))
//         })
//       }
//       csvRows.push(",")
//     })

//     const csvContent = csvRows.join("\n")
//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement("a")
//     link.href = url
//     link.setAttribute("download", filename)
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     URL.revokeObjectURL(url)
//   }

//   const totalPages = Math.ceil(totalRecords / pageSize)
//   const canGoPrev = pageIndex > 0
//   const canGoNext = pageIndex < totalPages - 1

//   const getPageNumbers = () => {
//     const pages = []
//     const maxVisible = 5
//     let start = Math.max(0, pageIndex - 2)
//     let end = Math.min(totalPages, start + maxVisible)

//     if (end - start < maxVisible) {
//       start = Math.max(0, end - maxVisible)
//     }

//     for (let i = start; i < end; i++) {
//       pages.push(i)
//     }
//     return pages
//   }

//   return (
//     <div className="table-responsive">
//       <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="Search by mobile or date/time..."
//           value={searchTerm}
//           onChange={e => {
//             setSearchTerm(e.target.value)
//             setPageIndex(0) // reset to first "page" of filtered results
//           }}
//         />
//         <div className="d-flex align-items-center gap-2">
//           <select
//             className="form-select w-auto"
//             value={pageSize}
//             onChange={e => setPageSize(Number(e.target.value))}
//           >
//             <option value={5}>Show 5</option>
//             <option value={10}>Show 10</option>
//             <option value={20}>Show 20</option>
//             <option value={50}>Show 50</option>
//           </select>

//           <button
//             className="btn btn-soft-primary btn-sm"
//             onClick={handleExportCSV}
//             disabled={
//               loading ||
//               (searchTerm.trim() ? filteredRows.length : tableData.length) === 0
//             }
//           >
//             <i className="mdi mdi-download me-1"></i> Export CSV
//           </button>
//         </div>
//       </div>

//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       ) : (searchTerm.trim() ? filteredRows.length : tableData.length) === 0 ? (
//         <div className="text-center py-5 text-muted">
//           <h5>
//             {tableData.length === 0
//               ? "No records found for the selected filters"
//               : "No matching records found for your search"}
//           </h5>
//         </div>
//       ) : (
//         <>
//           <table className="table table-bordered table-hover">
//             <thead className="table-light">
//               <tr>
//                 <th style={{ width: "50px" }}></th>
//                 <th>Date Time</th>
//                 <th>Mobile</th>
//                 <th>Opening</th>
//                 <th>Closing</th>
//                 <th>Withdraw</th>
//                 <th>Added</th>
//               </tr>
//             </thead>
//             <tbody>
//               {(searchTerm.trim() ? filteredRows : tableData).map(row => (
//                 <React.Fragment key={row.id}>
//                   <tr>
//                     <td className="text-center">
//                       <button
//                         className="btn btn-sm btn-link p-0 fs-5"
//                         onClick={() => toggleExpand(row.id)}
//                       >
//                         {expandedRows[row.id] ? "▼" : "▶"}
//                       </button>
//                     </td>
//                     <td>{row.dateTime}</td>
//                     <td>{row.mobile}</td>
//                     <td>{formatCurrency(row.opening)}</td>
//                     <td>{formatCurrency(row.closing)}</td>
//                     <td>{formatCurrency(row.withdraw)}</td>
//                     <td>{formatCurrency(row.added)}</td>
//                   </tr>

//                   {expandedRows[row.id] && (
//                     <tr>
//                       <td colSpan={7} className="p-0">
//                         {renderSubTable(row.subTransactions)}
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>

//           <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//             <div className="text-muted">
//               Showing{" "}
//               {searchTerm.trim() ? filteredRows.length : tableData.length} of{" "}
//               {totalRecords} entries
//               {totalRecords > 0 && (
//                 <span className="ms-2">
//                   Page {pageIndex + 1} of {totalPages}
//                 </span>
//               )}
//             </div>

//             <nav>
//               <ul className="pagination pagination-sm mb-0">
//                 <li className={`page-item ${!canGoPrev ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoPrev && fetchData(pageIndex - 1)}
//                     disabled={!canGoPrev}
//                   >
//                     Previous
//                   </button>
//                 </li>

//                 {getPageNumbers().map(pageNum => (
//                   <li
//                     key={pageNum}
//                     className={`page-item ${
//                       pageIndex === pageNum ? "active" : ""
//                     }`}
//                   >
//                     <button
//                       className="page-link"
//                       onClick={() => fetchData(pageNum)}
//                     >
//                       {pageNum + 1}
//                     </button>
//                   </li>
//                 ))}

//                 <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoNext && fetchData(pageIndex + 1)}
//                     disabled={!canGoNext}
//                   >
//                     Next
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </>
//       )}
//     </div>
//   )
// }

// export default NormalReportTable

// src/pages/Reports/tables/NormalReportTable.js
import React, { useState, useEffect, useMemo } from "react"
import { getCombinedTransactionReport } from "../../../helpers/api_helper"

const NormalReportTable = ({ filters, tabKey, sharedCache }) => {
  const [expandedRows, setExpandedRows] = useState({})
  const [tableData, setTableData] = useState([]) // current page data from API
  const [searchTerm, setSearchTerm] = useState("")
  const [loading, setLoading] = useState(true)
  const [totalRecords, setTotalRecords] = useState(0)
  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(5)

  const getCacheKey = (pIndex, pSize) => `${tabKey}-${pIndex}-${pSize}`

  const fetchData = async (
    newPageIndex = pageIndex,
    newPageSize = pageSize,
    forceRefresh = false
  ) => {
    const key = getCacheKey(newPageIndex, newPageSize)

    if (!forceRefresh && sharedCache.current.has(key)) {
      const cached = sharedCache.current.get(key)
      setTableData(cached.rows)
      setTotalRecords(cached.totalRecords) // ← Yeh line add ki – totalRecords cache se wapas set ho jayega
      setPageIndex(newPageIndex)
      setPageSize(newPageSize)
      setLoading(false)
      return
    }

    setLoading(true)
    const offset = newPageIndex * newPageSize

    try {
      const res = await getCombinedTransactionReport({
        limit: newPageSize,
        offset,
        startDate: filters?.startDate || null,
        endDate: filters?.endDate || null,
        mobileNumber:
          filters?.mobileNumbers?.length > 0 ? filters.mobileNumbers : null,
      })

      console.log("Normal Report API Response:", res)

      if (!res.success || !res.data) {
        setTableData([])
        setTotalRecords(0)
        sharedCache.current.delete(key)
        return
      }

      const currentTotal = res.totalRecords || 0
      setTotalRecords(currentTotal)

      let rows = []

      Object.entries(res.data || {}).forEach(([date, mobiles]) => {
        Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
          const openingClosing = categories.opening_closing || {}

          const withdrawTotal = categories.withdraw?.total?.amount || 0
          const addedTotal = categories.added_money?.total?.amount || 0

          const withdrawDetails = categories.withdraw?.details || []
          const addedDetails = categories.added_money?.details || []

          const subTransactions = [
            ...withdrawDetails.map(detail => ({
              dateTime: detail.time || "",
              type: "Withdraw",
              amount: detail.amount || 0,
              transactionId: detail.transaction_id || "N/A",
            })),
            ...addedDetails.map(detail => ({
              dateTime: detail.time || "",
              type: "Added Money",
              amount: detail.amount || 0,
              transactionId: detail.transaction_id || "N/A",
            })),
          ]

          rows.push({
            id: `${date}-${mobile}`,
            dateTime: openingClosing.opening_time || date || "",
            mobile: mobile.trim(),
            opening: openingClosing.opening || 0,
            closing: openingClosing.closing || 0,
            withdraw: withdrawTotal,
            added: addedTotal,
            subTransactions,
          })
        })
      })

      rows.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime))

      // Cache mein totalRecords bhi save kar rahe hain
      sharedCache.current.set(key, {
        rows,
        totalRecords: currentTotal,
        timestamp: Date.now(),
      })

      setTableData(rows)
      setPageIndex(newPageIndex)
      setPageSize(newPageSize)
    } catch (err) {
      console.error("Normal Report fetch error:", err)
      setTableData([])
      setTotalRecords(0)
      sharedCache.current.delete(key)
    } finally {
      setLoading(false)
    }
  }

  // Reset on filters or pageSize change
  useEffect(() => {
    setPageIndex(0)
    fetchData(0, pageSize)
  }, [filters, pageSize])

  // Client-side search filtering on current page data
  const filteredRows = useMemo(() => {
    if (!searchTerm.trim()) return tableData

    const term = searchTerm.toLowerCase().trim()

    return tableData.filter(row => {
      return (
        row.mobile.toLowerCase().includes(term) ||
        row.dateTime.toLowerCase().includes(term)
      )
    })
  }, [searchTerm, tableData])

  const formatCurrency = val => `₹${Number(val || 0).toLocaleString("en-IN")}`

  const toggleExpand = id => {
    setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }))
  }

  const renderSubTable = (subTransactions = []) => (
    <div className="bg-light p-4 border-top">
      <h6 className="mb-3 fw-semibold">Transaction History</h6>
      <div className="table-responsive">
        <table className="table table-bordered table-sm mb-0">
          <thead className="table-light">
            <tr>
              <th>Date Time</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Transaction ID</th>
            </tr>
          </thead>
          <tbody>
            {subTransactions.length > 0 ? (
              subTransactions.map((sub, idx) => (
                <tr key={idx}>
                  <td>{sub.dateTime || "N/A"}</td>
                  <td>{sub.type || "N/A"}</td>
                  <td>{formatCurrency(sub.amount)}</td>
                  <td>{sub.transactionId || "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center text-muted py-3">
                  No detailed transactions available in this report
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )

  const handleExportCSV = () => {
    const dataToExport = searchTerm.trim() ? filteredRows : tableData

    if (loading || dataToExport.length === 0) {
      alert("No data available to export right now. (Current view only)")
      return
    }

    const dateStr = new Date().toISOString().split("T")[0]
    const filename = `normal-report_${dateStr}.csv`

    const headers = [
      "Date Time (Main)",
      "Mobile",
      "Opening",
      "Closing",
      "Withdraw (Total)",
      "Added (Total)",
      "Transaction Date Time",
      "Type",
      "Amount",
      "Transaction ID",
    ]

    const csvRows = [headers.join(",")]

    dataToExport.forEach(row => {
      if (row.subTransactions.length === 0) {
        const mainValues = [
          `"${(row.dateTime || "").replace(/"/g, '""')}"`,
          `"${(row.mobile || "").replace(/"/g, '""')}"`,
          row.opening || 0,
          row.closing || 0,
          row.withdraw || 0,
          row.added || 0,
          "",
          "",
          "",
          "",
        ]
        csvRows.push(mainValues.join(","))
      } else {
        row.subTransactions.forEach(sub => {
          const values = [
            `"${(row.dateTime || "").replace(/"/g, '""')}"`,
            `"${(row.mobile || "").replace(/"/g, '""')}"`,
            row.opening || 0,
            row.closing || 0,
            row.withdraw || 0,
            row.added || 0,
            `"${(sub.dateTime || "").replace(/"/g, '""')}"`,
            `"${(sub.type || "").replace(/"/g, '""')}"`,
            sub.amount || 0,
            `"${(sub.transactionId || "").replace(/"/g, '""')}"`,
          ]
          csvRows.push(values.join(","))
        })
      }
      csvRows.push(",")
    })

    const csvContent = csvRows.join("\n")
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  const totalPages = Math.ceil(totalRecords / pageSize)
  const canGoPrev = pageIndex > 0
  const canGoNext = pageIndex < totalPages - 1

  const getPageNumbers = () => {
    const pages = []
    const maxVisible = 5
    let start = Math.max(0, pageIndex - 2)
    let end = Math.min(totalPages, start + maxVisible)

    if (end - start < maxVisible) {
      start = Math.max(0, end - maxVisible)
    }

    for (let i = start; i < end; i++) {
      pages.push(i)
    }
    return pages
  }

  return (
    <div className="table-responsive">
      <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
        <input
          type="text"
          className="form-control w-50"
          placeholder="Search by mobile or date/time..."
          value={searchTerm}
          onChange={e => {
            setSearchTerm(e.target.value)
            setPageIndex(0) // reset to first "page" of filtered results
          }}
        />
        <div className="d-flex align-items-center gap-2">
          <select
            className="form-select w-auto"
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
          >
            <option value={5}>Show 5</option>
            <option value={10}>Show 10</option>
            <option value={20}>Show 20</option>
            <option value={50}>Show 50</option>
          </select>

          <button
            className="btn btn-soft-primary btn-sm"
            onClick={handleExportCSV}
            disabled={
              loading ||
              (searchTerm.trim() ? filteredRows.length : tableData.length) === 0
            }
          >
            <i className="mdi mdi-download me-1"></i> Export CSV
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (searchTerm.trim() ? filteredRows.length : tableData.length) === 0 ? (
        <div className="text-center py-5 text-muted">
          <h5>
            {tableData.length === 0
              ? "No records found for the selected filters"
              : "No matching records found for your search"}
          </h5>
        </div>
      ) : (
        <>
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th style={{ width: "50px" }}></th>
                <th>Date Time</th>
                <th>Mobile</th>
                <th>Opening</th>
                <th>Closing</th>
                <th>Withdraw</th>
                <th>Added</th>
              </tr>
            </thead>
            <tbody>
              {(searchTerm.trim() ? filteredRows : tableData).map(row => (
                <React.Fragment key={row.id}>
                  <tr>
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-link p-0 fs-5"
                        onClick={() => toggleExpand(row.id)}
                      >
                        {expandedRows[row.id] ? "▼" : "▶"}
                      </button>
                    </td>
                    <td>{row.dateTime}</td>
                    <td>{row.mobile}</td>
                    <td>{formatCurrency(row.opening)}</td>
                    <td>{formatCurrency(row.closing)}</td>
                    <td>{formatCurrency(row.withdraw)}</td>
                    <td>{formatCurrency(row.added)}</td>
                  </tr>

                  {expandedRows[row.id] && (
                    <tr>
                      <td colSpan={7} className="p-0">
                        {renderSubTable(row.subTransactions)}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>

          <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div className="text-muted">
              Showing{" "}
              {searchTerm.trim() ? filteredRows.length : tableData.length} of{" "}
              {totalRecords} entries
              {totalRecords > 0 && (
                <span className="ms-2">
                  Page {pageIndex + 1} of {totalPages}
                </span>
              )}
            </div>

            <nav>
              <ul className="pagination pagination-sm mb-0">
                <li className={`page-item ${!canGoPrev ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => canGoPrev && fetchData(pageIndex - 1)}
                    disabled={!canGoPrev}
                  >
                    Previous
                  </button>
                </li>

                {getPageNumbers().map(pageNum => (
                  <li
                    key={pageNum}
                    className={`page-item ${
                      pageIndex === pageNum ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchData(pageNum)}
                    >
                      {pageNum + 1}
                    </button>
                  </li>
                ))}

                <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => canGoNext && fetchData(pageIndex + 1)}
                    disabled={!canGoNext}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </>
      )}
    </div>
  )
}

export default NormalReportTable
